import { getSassmallToken } from "./storage";
import { getInternationalizationPreference, updateInternationalizationPreference } from "./api/internationalization";

const currencyCode = (value: unknown) => String(value || "").trim().toUpperCase();

export function findAvailableCurrency(store: any, value: unknown) {
  const code = currencyCode(value);
  return store.currencyList.find((item: any) =>
    item.fromCurrencyCode === "CNY" && item.toCurrencyCode === code &&
    Number(item.exchangeRate) > 0 && item.activeFlag !== false && item.deleteFlag !== true,
  );
}

export async function applyAccountCurrencyPreference(store: any, hadLocalCurrency = true) {
  const token = getSassmallToken();
  if (!token || typeof window === "undefined") return false;
  const saved = store.initCurrentCurrency();
  if (hadLocalCurrency && findAvailableCurrency(store, saved?.toCurrencyCode)) return false;
  const preference = await getInternationalizationPreference();
  if (getSassmallToken() !== token) return false;
  const item = findAvailableCurrency(store, preference.currencyPreference);
  if (item) {
    store.saveCurrentCurrency(item);
    window.localStorage.setItem("currentCurrencySource", "ACCOUNT");
  }
  return Boolean(item);
}

export async function selectDisplayCurrency(store: any, value: unknown) {
  const item = findAvailableCurrency(store, value);
  if (!item) throw new Error("所选币种暂无可用汇率");
  const token = getSassmallToken();
  if (token) {
    await updateInternationalizationPreference({ currencyPreference: item.toCurrencyCode });
    if (getSassmallToken() !== token) throw new Error("登录状态已变化，请重新选择币种");
  }
  store.saveCurrentCurrency(item);
  window.localStorage.setItem("currentCurrencySource", "USER");
}
